module.exports = flarum.core.compat['tags/models/Tag'];